/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  ApprovalStatusLabel,
  convertApprovalStatus,
} from '../../../../../../api/enumerations';
import { listNoticeCompanies } from '../../../../../../api/theHive/notices';
import {
  ListNoticeCompaniesParams,
  NoticeCompaniesData,
} from '../../../../../../api/theHive/notices/types';
import { GlobalContext } from '../../../../../../context/global';
import { formatDate } from '../../../../../../helpers';
import useErrorMessage from '../../../../../../hooks/useErrorMessage';
import { TableSection } from '../styles';
import {
  StyledCell,
  StyledPagination,
  StyledRow,
  TableCellHeader,
} from './styles';

export function NoticeDetailsRequest(): JSX.Element {
  const [licenseResquest, setLicenseRequest] = useState<NoticeCompaniesData[]>(
    []
  );
  const [pageLicenseRequest, setPageLicenseRequest] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [licenseRequestTotalPages, setLicenseRequestTotalPages] = useState(0);
  const licenseRequestPerPage = 10;

  const { setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);
  const { notice: noticeIdParam } = useParams();
  const noticeId = parseInt(noticeIdParam as string, 10);
  const { getErrorMessage } = useErrorMessage();
  const navigate = useNavigate();

  const handleNavigate = (companyId: number): void => {
    navigate(`./request/${companyId}`);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ): void => {
    setPageLicenseRequest(value);
  };

  const handleLicenseRequest = async (): Promise<void> => {
    setLoadingRequest(true);
    try {
      const params: ListNoticeCompaniesParams = {
        publicNoticeId: noticeId,
        page: pageLicenseRequest,
        size: licenseRequestPerPage,
        search: '',
        approvalStatus: [
          ApprovalStatusLabel.PENDING,
          ApprovalStatusLabel.AWAITING_FORMALIZATION,
          ApprovalStatusLabel.FORMALIZATION_SUBMITTED,
        ],
      };
      const response = await listNoticeCompanies(params);

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (!response.data) throw new Error('Algo deu errado, tente novamente.');

      setLicenseRequest(response.data);
      setLicenseRequestTotalPages(response.detail.total_pages);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setErrorMessage(true);
      setOpenSnackbar(true);
    } finally {
      setLoadingRequest(false);
    }
  };

  useEffect(() => {
    if (noticeId) {
      handleLicenseRequest();
    }
  }, [noticeId, pageLicenseRequest]);

  return (
    <TableSection>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Pedidos de credenciamento
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader width="25%">Nome da empresa</TableCellHeader>
              <TableCellHeader align="center" width="25%">
                Data da solicitação
              </TableCellHeader>
              <TableCellHeader align="center" width="25%">
                Responsável
              </TableCellHeader>
              <TableCellHeader align="center" width="25%">
                Status
              </TableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingRequest ? (
              <StyledRow>
                <StyledCell colSpan={4} align="center">
                  <CircularProgress size={24} />
                </StyledCell>
              </StyledRow>
            ) : licenseResquest.length === 0 ? (
              <StyledRow>
                <StyledCell colSpan={4} align="center">
                  Nenhum pedido cadastrado.
                </StyledCell>
              </StyledRow>
            ) : (
              licenseResquest.map((item) => (
                <StyledRow
                  key={item.notice_company_id}
                  onClick={() => handleNavigate(item.notice_company_id)}
                >
                  <StyledCell>{item.licensed_company.company.name}</StyledCell>
                  <StyledCell align="center">
                    {item.requested_at ? formatDate(item.requested_at) : '—'}
                  </StyledCell>
                  <StyledCell align="center">
                    {item.licensed_company.company.responsible_user.name}
                  </StyledCell>
                  <StyledCell align="center">
                    {convertApprovalStatus(item.approval_status)}
                  </StyledCell>
                </StyledRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <StyledPagination
        page={pageLicenseRequest}
        count={licenseRequestTotalPages}
        onChange={handlePageChange}
      />
    </TableSection>
  );
}
